













































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import { CompendiumStore, store } from '@/store'

export default Vue.extend({
  name: 'cc-background-selector',
  props: {
    small: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    backgrounds: [],
  }),
  methods: {
    open() {
      this.$refs.dialog.show()
      this.backgrounds = getModule(CompendiumStore, this.$store).Backgrounds
    },
    choose(background: string) {
      this.$emit('select', background)
      this.$refs.dialog.hide()
    },
    getSkillName(skillId: string) {
      return store.getters.referenceByID('Skills', skillId).Name
    }
  },
})
